import { environmentHttpClient } from "client/Api/httpClient";
import { ResultMapperColor } from "client/Api/IntegrationBuilder/integrationBuilderFlows";
import { IntegrationFlowMultipleAuthenticationsAreRequiredModel } from "client/Api/IntegrationBuilder/integrationBuilderAuthentication";

export type ColoredValueModel<TValue> = {
	value: TValue;
	color: ResultMapperColor | null;
};

export type GeneralIntegrationFlowResultItemModel = {
	title: ColoredValueModel<string> | null;
	dateTime: ColoredValueModel<string> | null;
	subtitle1: ColoredValueModel<string> | null;
	subtitle2: ColoredValueModel<string> | null;
	subtitle3: ColoredValueModel<string> | null;
	description: ColoredValueModel<string> | null;
	link: string | null;
};

export enum GeneralIntegrationFlowLiveInformationResultStatus {
	Success = 1,
	AuthenticationIsRequired = 2,
	Failure = 3
}

export type GeneralIntegrationFlowResult = {
	status: GeneralIntegrationFlowLiveInformationResultStatus.Failure;
} | {
	status: GeneralIntegrationFlowLiveInformationResultStatus.AuthenticationIsRequired;
	authenticationModel: IntegrationFlowMultipleAuthenticationsAreRequiredModel;
} | {
	status: GeneralIntegrationFlowLiveInformationResultStatus.Success;
	items: readonly GeneralIntegrationFlowResultItemModel[];
};

export type LiveInformationRequestModel = {
	searchTerm: OptionalModel<string>;
};

export function getLiveInformation(
	integrationId: number,
	model: LiveInformationRequestModel,
	signal?: AbortSignal
): Promise<GeneralIntegrationFlowResult> {
	return environmentHttpClient.get<GeneralIntegrationFlowResult>(
		`Workspace/LiveInformation/AppIntegration/${integrationId}`,
		model,
		{ signal }
	);
}

export type GeneralIntegrationFlowConfiguration = {
	doesSupportSearch: boolean;
};

export function getFlowConfiguration(
	integrationId: number,
	signal?: AbortSignal
): Promise<GeneralIntegrationFlowConfiguration> {
	return environmentHttpClient.get<GeneralIntegrationFlowConfiguration>(
		`Workspace/LiveInformation/AppIntegration/${integrationId}/FlowConfiguration`,
		undefined,
		{ signal }
	);
}
